import {AbstractFilterComponent} from "./abstract-filter-component.js";
import DateFormat from "../../utils/date-format.js";
import {FilterLabel} from "./components/label.js";

export class FilterDatesRange extends AbstractFilterComponent {

	static selector = '.js-filter-dates-range';

	pickerInstanceFrom;
	pickerInstanceTo;

	selectedDateFrom;
	selectedDateTo;

	constructor(parent, filter, node) {
		super(parent, filter, node);
		this.init();
	}

	init() {
		let self = this;
		let filter = self.node;

		let from = filter.querySelector('.js-filter-dates-range__input-from');
		let to = filter.querySelector('.js-filter-dates-range__input-to');
		if (! from || ! to) {
			return;
		}

		self.pickerInstanceFrom = self.initFlatPicker(from);
		self.pickerInstanceTo = self.initFlatPicker(to);

		from.closest('.js-filter-dates-range__col').classList[from.value ? 'add' : 'remove']('filled');
		to.closest('.js-filter-dates-range__col').classList[to.value ? 'add' : 'remove']('filled');
	}

	initFlatPicker(selector) {
		let self = this;

		let instance = window.flatpickr(selector, self.getConfiguration(selector));
		instance.calendarContainer.classList.add('c-datepicker');
		instance.calendarContainer.classList.add('c-filter-dates-range__datepicker');

		return instance;
	}

	getConfiguration(selector) {
		let self = this;
		let config = Object.assign({}, selector.dataset);

		config.nextArrow = config.nextArrow || `<span class="icon-svg" aria-hidden="true"><svg class="icon-svg__svg" viewBox="0 0 16 16" width="16" height="16"><use xlink:href="${config.icons}#icon-arrow-circle-right"></use></svg></span>`;
		config.prevArrow = config.prevArrow || `<span class="icon-svg" aria-hidden="true"><svg class="icon-svg__svg" viewBox="0 0 16 16" width="16" height="16"><use xlink:href="${config.icons}#icon-arrow-circle-left"></use></svg></span>`;
		config.clickOpens = config.clickOpens || true;
		config.locale = window.flatpickrLocale(config.locale);
		config.disableMobile = true; // WTF...??

		config.onOpen = function(selectedDates, dateStr, instance) {
			instance.input.closest('.js-filter-dates-range__col').classList.add('opened');
		};

		config.onClose = function(selectedDates, dateStr, instance) {
			instance.input.closest('.js-filter-dates-range__col').classList.remove('opened');
		};

		config.onChange = function(selectedDates, dateStr, instance) {
			instance.input.closest('.js-filter-dates-range__col').classList[selectedDates.length ? 'add' : 'remove']('filled');
			let date = selectedDates.length ? selectedDates[0] : null;

			if (date) {

				// FROM
				if (instance === self.pickerInstanceFrom) {
					if (date) {
						self.selectedDateFrom = date;

						if (self.selectedDateTo && self.selectedDateTo.getTime() < date.getTime()) {
							self.clearDateTo();
						}

						self.pickerInstanceTo.set('minDate', date);
						self.pickerInstanceTo.setDate(self.selectedDateTo, true);

						// COTTAGES: Only 14 days
						if (document.querySelector('.js-filter-dates-range__input-to').dataset.setMaxDate) {
							let maxDate = new Date(date);
							maxDate.setDate(date.getDate() + 14);
							self.pickerInstanceTo.set('maxDate', maxDate);
						}

						// months switching
						self.pickerInstanceTo.jumpToDate(
							self.isLastDayInMonth(date) ? self.getNextMonthDate(date) : date
						);
					}
				}

				// TO
				if (instance === self.pickerInstanceTo) {
					self.selectedDateTo = date;
				}
			}

			self.componentStateChanged();
		};

		return config;
	}

	getLabels() {
		let self = this;
		let labels = [];

		['From', 'To'].forEach(type => {
			let picker = self['pickerInstance' + type];
			let date = picker.selectedDates.shift() || self['selectedDate' + type];
			let content = picker.input.dataset.labelPattern;
			let format = picker.input.dataset.labelDateFormat;

			if (date && content && format) {
				self['selectedDate' + type] = date;

				content = content.replace(/{date}/, DateFormat.format(date, format));
				let label = new FilterLabel(self, content, {type: type});

				self['label' + type] = label;
				labels.push(label);
			}
		});

		return labels;
	}

	labelDismissed(label) {
		let self = this;
		self.filter.setForceUpdateMode();

		if (label.parameters.type === 'From') {
			self.clearDateFrom();
			return;
		}

		if (label.parameters.type === 'To') {
			self.clearDateTo();
		}
	}

	clearDateFrom() {
		let self = this;

		self.selectedDateFrom = null;
		self.pickerInstanceFrom.clear();
	}

	clearDateTo() {
		let self = this;

		self.selectedDateTo = null;
		self.pickerInstanceTo.clear();
	}

	getFormData() {
		let self = this;
		let data = {};

		// from
		let pickerFrom = self.pickerInstanceFrom;
		let from = pickerFrom.selectedDates.shift() || self.selectedDateFrom;
		if (from) {
			data[self.getInputName(pickerFrom.input)] = DateFormat.format(from, 'Y-m-d');
		}

		// to
		let pickerTo = self.pickerInstanceTo;
		let to = pickerTo.selectedDates.shift() || self.selectedDateTo;
		if (to) {
			data[self.getInputName(pickerTo.input)] = DateFormat.format(to, 'Y-m-d');
		}

		if (Object.keys(data).length) {
			let ret = {};
			ret[self.getInputsGroupName()] = data;

			return ret;
		}

		return data;
	}

	getInputsGroupName() {
		let self = this;
		return self.pickerInstanceFrom.input.name.match(/([^[]+)/)[0];
	}

	getInputName(input) {
		return input.name.match(/\[(.*?)]/)[1];
	}

	isLastDayInMonth(dateTime) {
		return new Date(dateTime.getTime() + 86400000).getDate() === 1;
	}

	getNextMonthDate(dateTime) {
		if (dateTime.getMonth() === 11) {
			return new Date(dateTime.getFullYear() + 1, 0, 1);
		}

		return new Date(dateTime.getFullYear(), dateTime.getMonth() + 1, 1);
	}
}
